export const SELLER_WEBAPP_ROUTES = {
  LOGIN: '/login',
  SURVEY_FORM: '/form',
  ERROR_SCREEN: '/error-screen',
  MANAGE_CUSTOMERS_LIST: '/manage/customers',
  MANAGE_CUSTOMERS_DETAILS: '/manage/customer/:customerId',
  MANAGE_CUSTOMERS_COMPANY_DETAILS:
    '/manage/customer/:customerId/company-details',
  CUSTOMER_DETAILS: '/active-customer/details',
  ORDERS_LIST: '/orders',
  ACCEPT_ORDERS_LIST: '/orders/submitted',
  DRAFT_ORDERS_LIST: '/orders/draft',
  FULFILLED_ORDERS_LIST: '/orders/accepted',
  ORDER_DETAILS: '/order/details',
  READY_TO_DISPATCH: '/order/dispatch',
  CREATE_ORDER: '/order/create',
  CREATE_INVOICE_SUCCESS: '/success',
  ADD_PRODUCT: '/product/add',
  PRODUCT_AVAILABILITY: '/product/availability',
  SHARE_PRODUCTS: '/product/share',
  PRICING: '/pricing',
  CUSTOMER_PRICING: '/pricing/customer',
  CFA_PRICING: '/pricing/cfa',
  CUSTOMER_PRICING_PRODUCTS: '/pricing/customer/products',
  CFA_PRICING_PRODUCTS: '/pricing/cfa/products',
  INVOICES_LIST: '/invoices',
  UPLOAD_INVOICE: '/invoice/upload',
  UPLOAD_INVOICE_CUSTOMER: '/invoice/upload/:customerId',
  INVOICE_DETAILS: '/invoices/:invoiceId',
  SELECT_INVOICES: '/invoices/select',
  TURNOVER_INVOICES: '/turnover-invoices',
  TURNOVER_INVOICES_DETAILS: '/turnover-invoices/:invoiceId',
  VIEW_SELECTED_ORDERS: '/orders/selected',
  VIEW_SELECTED_PAYMENTS: '/payments/selected',
  VIEW_SELECTED_INVOICES: '/invoices/selected',
  VIEW_SELECTED_DISPATCH_NOTES: '/dispatch-notes/selected',
  UPLOAD_DISPATCH_NOTE: '/dispatch-note/upload',
  UPLOAD_DISPATCH_NOTE_CUSTOMER: '/dispatch-note/upload/:customerId',
  PAYMENT: '/payment',
  ACCEPT_PAYMENTS: '/payments/accept',
  PAYMENT_DETAILS: '/payment/details',
  EDIT_PAYMENT: '/payment/edit',
  COLLECT_PAYMENT: '/payment/collect',
  CONVERSATION_LIST: '/conversations',
  CONVERSATION_MESSAGES: '/conversations/:conversationId',
  NOTIFICATIONS: '/notifications',
  LOADING_SCREEN: '/loading',
  SEND_INVOICES: '/invoices/send',
  SEND_PAYMENT_REQUEST: '/invoices/payment-request',
  CHOOSE_PLAN: '/choose-plan',
  SEND_LEDGER: '/customers/send-ledger',
  LEDGER_LIST: '/customers/:customerId/ledger',
  PREVIEW_LEDGER_PDF: '/customers/:customerId/ledger/pdf',
  DISPATCH_NOTES: '/dispatch-notes',
  DISPATCH_NOTE_DETAILS: '/dispatch-notes/:dispatchNoteId',
  DISPATCH_NOTE_EDIT: '/dispatch-notes/edit',
  PRODUCTS_LIST: '/products/:customerId',
  CART: '/cart/:customerId',
  VIEW_CUSTOMER_LIST: '/customers/list',
  ADD_CUSTOMER: '/customer/add',
  ADD_CFA: '/customer/add/cfa',
  DIGITAL_ORDERS: '/digital-orders',
  DIGITAL_ORDERS_BEAT_PLAN: '/digital-orders/beat-plans',
  DIGITAL_ORDERS_BEAT_PLAN_CUSTOMERS: '/digital-orders/beat-plan/customers',
  SELECT_TEMPLATE: '/digital-orders/template',
  PREVIEW_TEMPLATE: '/digital-orders/template/preview/:templateId',
  SEMANTIC_QUERY_LIST: '/semantic/query',
  SEMANTIC_QUERY_DETAIL: '/semantic/query/details',
  SEMANTIC_QUERY_CONVERSATION: '/semantic/query/details/:conversationId',
};

export const SELLER_HUB_LOGIN_ROUTES = {
  LOGIN: '/login',
  VERIFY_OTP: '/verifyOtp',
};

export const SELLER_WEBAPP_SHARE_ROUTES = {
  SHARE_AVAILABILTY: `${SELLER_WEBAPP_ROUTES.SHARE_PRODUCTS}/catalog`,
  VIEW_SELECTED_PRODUCTS: `${SELLER_WEBAPP_ROUTES.SHARE_PRODUCTS}/view-selected`,
  SELECT_SHARE_TEMPLATE: `${SELLER_WEBAPP_ROUTES.SHARE_PRODUCTS}/share-template`,
};

export const FIELD_OPS_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  ERROR_SCREEN: '/error-screen',
  CUSTOMER_LIST: '/customers',
  ROUTE_DETAILS: '/customers/route/:routeId',
  CUSTOMER_PROFILE: '/customers/profile/:customerId',
  CUSTOMER_COMPANY_DETAILS: '/customers/profile/:customerId/company-details',
  PRODUCTS_LIST: '/products/:customerId',
  UPLOAD: '/upload',
  DAYBOOK: '/daybook',
  DISPATCH_NOTES: '/daybook/dispatch-notes',
  DISPATCH_NOTE_DETAILS: '/daybook/dispatch-notes/:dispatchNoteId',
  ORDERS_LIST: '/daybook/orders',
  INVOICES_LIST: '/daybook/invoices',
  PAYMENT: '/daybook/payments',
  ORDER_DETAILS: '/daybook/orders/details',
  INVOICE_DETAILS: '/daybook/invoices/:invoiceId',
  PAYMENT_DETAILS: '/daybook/payments/details',
  VIEW_SELECTED_ORDERS: '/daybook/orders/selected',
  VIEW_SELECTED_PAYMENTS: '/daybook/payments/selected',
  VIEW_SELECTED_INVOICES: '/daybook/invoices/selected',
  VIEW_SELECTED_DISPATCH_NOTES: '/daybook/dispatch-notes/selected',
  ADD_PRODUCT: '/daybook/product/add',
  SEND_INVOICES: '/daybook/invoices/send',
  SEND_PAYMENT_REQUEST: '/daybook/invoices/payment-request',
  EDIT_PAYMENT: '/daybook/payment/edit',
  FIND_REPLACE_CUSTOMER: '/find-replace-customer',
  ISSUES: '/customers/profile/:customerId/issues',
  ISSUE_DETAILS: '/customers/profile/:customerId/issues/details',
  OFFLINE_CART: '/cart/:customerId',
  OFFLINE_CART_LIST: '/cart',
  LEDGER_LIST: '/customers/:customerId/ledger',
  PREVIEW_LEDGER_PDF: '/customers/:customerId/ledger/pdf',
  SEND_LEDGER: '/customers/send-ledger',
  CUSTOMER_CHECK_IN: '/customers/check-in/:customerId',
  CUSTOMER_PROFILE_INVOICE: '/customers/profile/:customerId/invoice',
  CUSTOMER_PROFILE_INVOICE_DETAILS:
    '/customers/profile/:customerId/invoice/:invoiceId',
  CUSTOMER_PROFILE_ORDER: '/customers/profile/:customerId/order',
  CUSTOMER_PROFILE_ORDER_DETAILS:
    '/customers/profile/:customerId/order/:orderId',
  CUSTOMER_PROFILE_PAYMENT: '/customers/profile/:customerId/payment',
  CUSTOMER_PROFILE_PAYMENT_DETAILS:
    '/customers/profile/:customerId/payment/:paymentId',
  VIEW_CUSTOMER_LIST: '/customers/list',
  CUSTOMER_DETAILS: '/customer/:customerId',
  ADD_CUSTOMER: '/customer/add',
  ADD_CFA: '/customer/add/cfa',
  ASSIGN_ROUTES: '/customer/assign/routes',
  ASSIGN_BEAT_PLAN: '/customer/assign/beat-plan',
  CUSTOMER_PROFILE_DISPATCH_NOTE:
    '/customers/profile/:customerId/dispatch-note',
  SYNC: '/sync',
  OFFLINE_COLLECT_PAYMENT: '/payment/collect',
  OFFLINE_PAYMENT_DETAILS: '/payment/:customerId',
};
